import {computed, override} from "mobx";
import {ANALYTICS} from "../../../../../third-party-services/analytics/analytics-consts";
import {NewMatchesFilterTabModel} from "./new-matches-filter.tab-model";
import type {BaseLinkModel} from "../../../../../infrastructure/models/link/base-link-model";
import {ENTITY_SCORES} from "../../../../../widgets/entity-scores-widget/entity-scores-widget.consts";
import {NEW_COMPETITOR_CONTAINER} from "../../../../../containers/competitor-container/competitor-container.consts";

export class NewMatchesFilterResultsTabModel extends NewMatchesFilterTabModel {
  @computed get linkModel(): BaseLinkModel {
    const linkModel: BaseLinkModel = this.entity ? new this.linkModelType(this.entity.id, this.entity.sport.nameForURL, this.entity.nameForURL, NEW_COMPETITOR_CONTAINER.FILTERS.matches,  super.itemHashParams(ENTITY_SCORES.URL_FILTERS.results), this.entity.isFollow) : null;
    linkModel.replace = true;

    return linkModel;
  }
  @override get isVisible(): Boolean {
    return true;
  }

  get isActive(): Boolean {
    const isResults: Boolean = this.currentLinkModel.hashParams?.results === 'results';

    return isResults;
  }

  get elementId(): String {
    return 'navigation-tabs_results';
  }

  get analyticsName(): Object {
    return ANALYTICS.TAB_NAMES.results;
  }

  get eventName(): String {
    return null;
  }
}
